<template>
  <div class="section-title" :class="{'section-title--subsection': subsection}">
    <h2 class="section-title__title">
      <slot></slot>
    </h2>
    <div class="section-title__divider"></div>
  </div>
</template>

<script>
export default {
  props: {
    subsection: Boolean
  }
}
</script>

<style lang="scss" scoped>
.section-title {
  width: 100%;
  margin-right: 30px;

  &--subsection {
    .section-title__title {
      font-size: 0.95em;
    }

    .section-title__divider {
      width: 35vw;
    }
  }

  &__title {
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    font-size: 1.2em;
    color: $borderAccent;
  }

  &__divider {
    height: 1px;
    width: 44vw;
    background-color: $borderGrey;
    margin-bottom: 22px;
  }
}
</style>
